// extracted by mini-css-extract-plugin
export default {"filter-row-item":"table-filter-row_filter-row-item__tfsWA"};